export default __webpack_public_path__ + "static/media/voyages-black.11c62829.png";